import React, { useState } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL;

// My Profile — lets a user edit their friendly display name.
export default function ProfilePage({ user, onSaved }) {
  const initial = user?.display_name || `${user?.first_name || ''} ${user?.last_name || ''}`.trim() || user?.username || '';
  const [name, setName] = useState(initial);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const [error, setError] = useState(null);

  const save = async () => {
    setSaving(true); setSaved(false); setError(null);
    try {
      const res = await axios.put(`${API}/staff/me`, { display_name: name.trim() },
        { headers: { Authorization: 'Bearer ' + localStorage.getItem('token') } });
      onSaved && onSaved(res.data);
      setSaved(true);
    } catch (e) {
      setError(e.response?.data?.error || 'Failed to save.');
    } finally {
      setSaving(false);
    }
  };

  const label = { display: 'block', fontSize: '11px', fontWeight: 600, color: '#6B7280', marginBottom: '6px', textTransform: 'uppercase', letterSpacing: '0.04em' };
  const input = { width: '100%', padding: '10px 12px', border: '1px solid #E5E7EB', borderRadius: '8px', fontSize: '14px', outline: 'none', boxSizing: 'border-box' };

  return (
    <div style={{ padding: '40px', maxWidth: '560px' }}>
      <h2 style={{ marginTop: 0, fontSize: '24px', fontWeight: 600, color: '#1f2937' }}>My Profile</h2>
      <p style={{ color: '#5F5E5A', fontSize: '13px', lineHeight: 1.6, marginBottom: '28px' }}>
        Your friendly name is how you appear across the portal.
      </p>

      <div style={{ marginBottom: '20px' }}>
        <label style={label}>Friendly name</label>
        <input value={name} onChange={(e) => { setName(e.target.value); setSaved(false); }}
          placeholder="e.g. Michael Emmetti" style={input} maxLength={120} />
        <p style={{ fontSize: '11px', color: '#9CA3AF', marginTop: '6px' }}>
          Shown in the sidebar, chat, and around the app. Leave blank to use your name on file.
        </p>
      </div>

      <div style={{ marginBottom: '24px' }}>
        <label style={label}>Username</label>
        <input value={user?.username || ''} disabled style={{ ...input, background: '#F9FAFB', color: '#9CA3AF' }} />
        <p style={{ fontSize: '11px', color: '#9CA3AF', marginTop: '6px' }}>Your login username can't be changed here — contact IT.</p>
      </div>

      {error && <div style={{ color: '#9B3A1F', fontSize: '13px', marginBottom: '12px' }}>{error}</div>}

      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        <button onClick={save} disabled={saving}
          style={{ padding: '10px 20px', background: 'var(--caam-accent)', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '14px', fontWeight: 600, cursor: saving ? 'default' : 'pointer', opacity: saving ? 0.6 : 1 }}>
          {saving ? 'Saving…' : 'Save'}
        </button>
        {saved && <span style={{ fontSize: '13px', color: '#10B981', fontWeight: 600 }}>Saved ✓</span>}
      </div>
    </div>
  );
}
